import { useState } from 'react'
import { Box, Button, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import SubscriptionFileUploader from '../../Components/SubscriptionFileUploader'
import { BATCH_UPLOAD } from '../../Graphql/Mutations'
import { BATCH_UPLOAD_SUBSCRIPTION } from '../../Graphql/Subscriptions'
import { AdminPaths } from '../../Routes/Paths'
import Message from '../../Components/Message'
import { Error } from '../../Types/MessageType'
import FormCard from '../../Components/Cards/FormCard'
import { BATCH_UPLOAD_TEMPLATE } from '../../Constants/fileUrls'

const BatchUpload = () => {
  const navigate = useNavigate()
  const [alert, setAlert] = useState<Error>()
  const { COHORT_PATH } = AdminPaths

  return (
    <>
      <Box sx={{ mb: 3 }} display={'flex'} justifyContent={'flex-end'}>
        <Box flexGrow={1} sx={{ pr: 3 }}>
          {!!alert?.message ? (
            <Message
              type={alert?.type}
              message={alert.message}
              variant={'filled'}
            />
          ) : null}
        </Box>
        <Stack direction={'row'} spacing={2}>
          <Button
            sx={{ px: 5, py: 1, height: '45px', color: 'white' }}
            variant='contained'
            onClick={() => navigate(COHORT_PATH)}
          >
            Back
          </Button>
        </Stack>
      </Box>

      <FormCard heading={'Upload Batch'} headingStyle={{ color: 'black' }}>
        <SubscriptionFileUploader
          uploaderMutation={BATCH_UPLOAD}
          uploaderSubscription={BATCH_UPLOAD_SUBSCRIPTION}
          responseKey='batchUploaderSubscription'
          sampleUrl={BATCH_UPLOAD_TEMPLATE}
        />
      </FormCard>
    </>
  )
}

export default BatchUpload
